import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { STORAGE_KEYS } from '@/constants';

interface TenantScopeState {
	/** Who picked it: another account signing in here never inherits it. */
	userId: string | null;
	/** Tenant shown on the list screens; `null` = the caller's own. */
	tenantId: string | null;
	setTenant: (userId: string, tenantId: string | null) => void;
}

/**
 * Tenant a platform admin picked in the header. Shared by every list screen
 * and kept across navigation and reloads (localStorage).
 */
export const useTenantScopeStore = create<TenantScopeState>()(
	persist(
		(set) => ({
			userId: null,
			tenantId: null,
			setTenant: (userId, tenantId) => set({ userId, tenantId }),
		}),
		{
			name: STORAGE_KEYS.tenantScope,
			storage: createJSONStorage(() => localStorage),
			partialize: ({ userId, tenantId }) => ({ userId, tenantId }),
		},
	),
);
